import React from "react";
import FeatureSection from "../components/FeatureSection";

const featureImage1 = "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe4885c39a459a65f74e7b_refer%20and%20earn%20(1).png";
const featureImage2 = "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe4b861c9bdb41fcb75d96_Group%201000005212.png";
const featureImage3 = "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe4cda49926851b88151ef_portrait-excited-young-man-looking-his-smartphone%201.png";


function ReferralPage() {
  return (
    <div className="flex flex-col">
    {/* Section 1 */}
    <FeatureSection
      image={featureImage1}
      title="
      🎉 Refer a Friend — Everyone Wins!


          "
      description="
Spread the word. Earn rewards. Help your friends discover great service.

          "
    />

    {/* Section 2 */}
    <FeatureSection
      image={featureImage2}
      title="
🔗 Your Personalized Referral Link
          "
      description="
Easily share your unique link with friends via email, text, or social media. No special tools needed—just copy, paste, and send!
      
          "
      reverse
    />

    {/* Section 3 */}
    <FeatureSection
      image={featureImage3}
      title="
      💸 Get Rewarded Instantly
          "
      description="
When your friend books their first service, you get a $10 coupon, loyalty points, or a discount. Rewards are automatically applied—no hoops to jump through.
      
          "
    />
  </div>
  )
}

export default ReferralPage